<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-button @click="onSearch" variant="info" class="p-2" v-if="this.showButton">
      <span v-if="!this.bButtonIcon">Buscar</span>
      <i v-if="this.bButtonIcon" class="zmdi zmdi-search"></i>
    </b-button>
  </div>
  <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" dialog-class="modal-search">
       <div class="modal-body">
          <form @submit.stop.prevent="searching">
            <b-row>
              <b-col>
              <b-form-group id="input-group-2"
                  label="Ingrese descripción a buscar:" label-for="input-2">
                  <div class="col-md-12 d-inline-flex align-items-center mb-5">
                    <b-form-input
                    id="input-2"
                    class="mr-2"
                    :state="($v.resoursetosearch.$dirty && submitted)? !$v.resoursetosearch.$error : null"
                    v-model.trim="resoursetosearch"
                    >
                    </b-form-input>
                    <b-button size="sm" variant="info" type="submit">
                      Buscar
                    </b-button>
                  </div>
              </b-form-group>
              </b-col>
            </b-row>
            <div class="row my-div-scroll">
              <div class="col-lg-6" v-for="audio in resources" v-bind:key="audio.ID">
                <div class="row consigna-card">
                  <div class="col-lg-12 m-b-5 d-inline-flex align-items-center justify-content-between">
                    <div class="text-muted mb-2 mt-3" style="width:80%">{{audio.NOMBRE}}</div>
                    <div class="hover mr-2 mt-1">
                      <b-button size="sm" variant="info" @click="$emit('selected', audio)">
                        Seleccionar
                      </b-button>
                    </div>
                </div>
                <div class="col-lg-12">
                   <audio :src="getTranslation(audio.FICHERO)" controls="controls"
                              style="width:100%" type="audio/mpeg" preload="preload">
                    </audio>
                </div>
            </div>
            </div>
          </div>
        </form>
      </div>

      <template v-slot:modal-footer>
        <div class="col-md-12 d-flex justify-content-end mb-3">
          <b-button @click="onCreate" variant="success" class="p-2">
            <span> <i class="zmdi zmdi-plus"></i> Crear recurso</span>
          </b-button>
        </div>
      </template>

    </b-modal>
</div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import translationMixin from '../../../mixins/translation';

export default {
  props: {
    idModal: {
      type: String,
    },
    bButtonIcon: {
      type: Boolean,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [translationMixin],
  data() {
    return {
      submitted: false,
      resoursetosearch: null,
      resources: [],
      infoModal: {
        id: this.idModal,
        title: 'Buscador de consignas orales',
      },
    };
  },
  validations: {
    resoursetosearch: {
      required,
      minLength: minLength(2),
    },
  },
  methods: {
    onSearch() {
      this.resources = [];
      this.resoursetosearch = null;
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    async searching() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      this.resources = [];
      this.loading = true;
      const response = await this.axios.get('writtenorals/searching', {
        params: {
          resoursetosearch: this.resoursetosearch,
        },
      });
      this.resources = response.data;
      this.loading = false;
    },
    onCreate() {
      const routeData = this.$router.resolve({ name: 'writtenorals' });
      window.open(routeData.href, '_blank');

      setTimeout(() => {
        const bc = new BroadcastChannel('new_resource_writtenorals_open');
        bc.postMessage({});
      }, 500);
    },
  },
  mounted() {
    const self = this;
    const bc = new BroadcastChannel('new_resource_writtenorals');
    bc.onmessage = (ev) => {
      self.resources.push(ev.data);
    };
  },
};
</script>
<style>
.consigna-card {
  min-height: 230px;
  margin: 10px 10px;
  border-radius: 1rem;
  border: 1px solid #cdcdcd;
  background-color: #fff;
  padding-bottom: 10px;
}
.hover {
  -moz-transition: all 0.5s;
  -o-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  width: 120px;
  display: block;
  text-align: right;
  margin-left: 10px;
}
</style>
